var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71021 5.6993C5.32021 6.0893 5.32021 6.7193 5.71021 7.1093L10.5902 11.9993L5.70021 16.8893C5.31021 17.2793 5.31021 17.9093 5.70021 18.2993C6.09021 18.6893 6.72022 18.6893 7.11022 18.2993L12.0002 13.4093L16.8902 18.2993C17.2802 18.6893 17.9102 18.6893 18.3002 18.2993C18.6902 17.9093 18.6902 17.2793 18.3002 16.8893L13.4102 11.9993L18.3002 7.1093C18.6902 6.7193 18.6902 6.0893 18.3002 5.6993C17.9102 5.3093 17.2802 5.3093 16.8902 5.6993L12.0002 10.5893L7.11021 5.6993C6.73021 5.3193 6.09021 5.3193 5.71021 5.6993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close_white.b43817b121787501bf312e19208a1723.svg";
export { ForwardRef as ReactComponent };